import React from "react";

import icoTooltipInfo from "@src/assets/ico_tooltip_info.png";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";
import styled from "styled-components";

interface PackageCardProps {
    title: string;
    packages: TicketPackageListResponseDto[];
    singleTicketImage: string;
    multipleTicketsImage?: string;
    active: boolean;
    onTitleClick: () => void;
    onPackageClick: (data: TicketPackageListResponseDto) => void;
    onScroll: (ref: HTMLElement | null) => void;
}

const PackageCard = ({
    title,
    packages,
    singleTicketImage,
    multipleTicketsImage,
    active,
    onTitleClick,
    onPackageClick,
    onScroll,
}: PackageCardProps) => {
    return (
        <PackageBoxStyle className={active ? "packageBox active" : "packageBox"} ref={(ref) => onScroll(ref)}>
            <div className={"titleBox"} onClick={onTitleClick}>
                <h3>{title}</h3>
                <img src={icoTooltipInfo} />
            </div>
            {packages.length > 0 &&
                packages.map((el) => {
                    return (
                        <article key={el.code} id={el.code} className="items" onClick={() => onPackageClick(el)}>
                            <div className="imageBox">
                                {multipleTicketsImage ? (
                                    <img
                                        src={el.quantity > 1 ? multipleTicketsImage : singleTicketImage}
                                        className={el.quantity > 1 ? "multiple" : ""}
                                    />
                                ) : (
                                    <img src={singleTicketImage} />
                                )}
                            </div>
                            <div>
                                <span>{el.name}</span>
                                {el.discountString && <small>{el.discountString}</small>}
                            </div>
                            <span className="price">{el.discountPrice.toLocaleString()}원</span>
                        </article>
                    );
                })}
        </PackageBoxStyle>
    );
};

export default PackageCard;

const PackageBoxStyle = styled.section`
    padding: 24px 14px 14px;

    &.active {
        background: #f6faff;
    }
    .titleBox {
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        & > h3 {
            font-size: 18px;
            font-weight: 700;
        }
        & > img {
            width: 20px;
            height: 20px;
            margin-left: 8px;
        }
    }
    .items {
        display: flex;
        align-items: center;
        width: 100%;
        background: #fff;
        border: 1px solid #c9c9c9;
        border-radius: 14px;
        font-size: 16px;
        box-sizing: border-box;
        padding: 14px;
        margin-bottom: 14px;
        font-size: 14px;

        .radioItem {
            margin-right: 10px;

            &.hidden {
                display: none;
            }
        }

        .imageBox {
            position: relative;
            margin: 0;

            min-width: 50px;
            height: 50px;

            border-radius: 8px;
            background-color: #f6faff;

            display: flex;
            align-items: center;
            justify-content: center;

            & > img {
                width: 38px;
                height: 38px;

                &.multiple {
                    width: 50px;
                    height: 50px;
                }
            }
        }
        & > div {
            display: flex;
            flex-direction: column;
            margin-left: 8px;

            & > span {
                word-break: keep-all;
                line-height: 1.1;
            }
            & > small {
                margin-top: 7px;
                color: #ff0000;
            }
        }
        & > .price {
            width: fit-content;
            min-width: 95px;
            height: 40px;
            background: #fff;
            border-radius: 8px;
            margin-left: auto;
            text-align: center;
            line-height: 40px;
            word-break: keep-all;
        }
    }

    .items:active {
        border: 1px solid #2275ee;
        box-shadow: inset 0 0 0 1px #2275ee;
    }
`;
